import { proxy } from "valtio";
import { ConsoleLogger, LogLevel } from "amazon-chime-sdk-js";
import { State } from "./types";

const initialState: State = {
    title: "",
    meetingId: "",
    mainMeetingId: "",
    parentMeetingTitle: "",
    status: "join",
    breakoutRooms: [],

    layoutType: "tiled",
    isMuted: false,
    isVideoEnabled: false,
    isEffectsSupported: false,
    isPreviewVideoEnabled: false,
    videoQuality: "540p",

    currentUser: {
        attendeeId: "",
    },

    logger: new ConsoleLogger("MeetingLogs", LogLevel.OFF),
    audioInputDevices: [],
    audioOutputDevices: [],
    videoInputDevices: [],
    unmuteIds: [],
    attendeeIds: [],
    activeSpeakerIds: [],
    screenShareIds: [],

    roster: {},
    tileIdToAttendeeId: {},
    attendeeIdToTileId: {},
    attendeeIdToVolume: {},
    attendeeIdToMuted: {},
    attendeeIdToSignalStrength: {},
    attendeeIdToRaised: {},

    recording: {},

    chat: {
        isOpen: false,
        unreadCount: 0,
        messages: [],
    },

    breakout: {
        rooms: [],
        isFetching: false,
        isLoading: false,
    },
};

export const state = proxy<State>({ ...initialState });

export function fromOrganizer(senderExternalUserId: string) {
    return senderExternalUserId.split("#")[0] === state.organizerId;
}
